export {BiometricStorageModule} from '../src/Biometric/BiometricStorageModule';
export {IBiometricStorage, SupportedBiometricMethod} from '../src/Biometric/IBiometricStorage';